export const setUserData = (isLoggedIn, userData) => {
    return {
        type: "USERDATA_UPDATE",
        payload: {
            isLoggedIn,
            userData
        }
    };
};